module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-02.e315bdf0.jpg";